{
  "dss": {
    "button": {
      "back": "رجوع",
      "cancel": "إلغاء",
      "close": "إغلاق",
      "confirmDelete": "نعم، احذف",
      "continue": "متابعة",
      "logout": "تسجيل الخروج",
      "passwordReset": "إعادة تعيين كلمة المرور",
      "save": "حفظ",
      "verify": "تحقق"
    },
    "error": {
      "403": "لا تملك صلاحية الوصول إلى هذه الصفحة.",
      "404": "الصفحة المطلوبة غير موجودة.",
      "generic": "حدث خطأ. يرجى المحاولة لاحقًا.",
      "throttling": "محاولات كثيرة جدًا. تم حظر هذه العملية مؤقتًا.",
      "title": "خطأ",
      "title403": "تم رفض الوصول",
      "title404": "الصفحة غير موجودة"
    },
    "footer": {
      "imprint": "البيان القانوني",
      "legalEntity": "ANDREAS STIHL AG & Co. KG, D-71336 Waiblingen",
      "privacy": "سياسة الخصوصية",
      "terms": "الشروط والأحكام"
    },
    "label": {
      "CRMAccountNumber": "رقم حساب CRM",
      "contact": "اتصال",
      "email": "البريد الإلكتروني",
      "faq": "الأسئلة الشائعة",
      "female": "السيدة",
      "firstname": "الاسم الأول",
      "help": "مساعدة",
      "language": "اللغة",
      "lastname": "اسم العائلة",
      "male": "السيد",
      "needHelp": "هل تحتاج مساعدة؟",
      "newPassword": "كلمة مرور جديدة",
      "newPassword2": "تأكيد كلمة المرور الجديدة",
      "oldPassword": "كلمة المرور الحالية",
      "organization": "المؤسسة",
      "password": "كلمة المرور",
      "required": "حقل مطلوب",
      "salutation": "التحية",
      "select": "يرجى الاختيار"
    },
    "lang": {
      "de": "الألمانية"
    },
    "link": {
      "contact": "https://support.stihl.com/en-INT/websso-ext-contact/",
      "faq": "https://support.stihl.com/en-INT/externalkbsearchwebsso/"
    },
    "page": {
      "confirm": {
        "title": "تأكيد التسجيل",
        "wait": "يرجى الانتظار حتى يكتمل تأكيد الحساب."
      },
      "otp": {
        "btnResend": "إعادة إرسال رمز التحقق عبر البريد الإلكتروني",
        "msg": {
          "invalidOTP": "كلمة المرور لمرة واحدة التي تم إدخالها غير صالحة.",
          "resendFail": "فشل في إعادة إرسال الرمز. يرجى المحاولة لاحقًا."
        },
        "spamDetail": "تحقق من صندوق الوارد ومجلد البريد العشوائي لرسالة من STIHL Support (noreply{'@'}stihl-sso.com)",
        "spamTitle": "ألم تصلك رسالة بريد إلكتروني؟",
        "subtitle": "لمتابعة العملية، تحتاج إلى التحقق من عنوان بريدك الإلكتروني.",
        "title": "تحقق من حساب المستخدم",
        "txtVerifyMail": "الرجاء إدخال رمز التحقق الجديد الذي أرسلناه إلى عنوان بريدك الإلكتروني {email}"
      },
      "personal": {
        "msg": {
          "noChange": "لا توجد تحديثات لإجرائها.",
          "updateError": "فشل حفظ البيانات الشخصية.",
          "updated": "تم تحديث البيانات الشخصية.",
          "userLoadErr": "حدث خطأ. يرجى المحاولة لاحقًا."
        },
        "secOrganization": "المؤسسة",
        "secPersonal": "شخصي",
        "secSettings": "الإعدادات المفضلة",
        "title": "المعلومات الشخصية"
      },
      "postPwSet": {
        "info": "يمكنك الآن استخدام كلمة المرور الجديدة الخاصة بك.",
        "link_name": "المتابعة إلى بوابة الخدمة الذاتية",
        "link_url": "https://b2bportal.stihl.de",
        "title": "تمت إعادة تعيين كلمة المرور الخاصة بك"
      },
      "resetPW": {
        "title": "أعد تعيين كلمة المرور الخاصة بك"
      },
      "security": {
        "2fa": {
          "availableMethods": "طرق المصادقة الثنائية المتاحة:",
          "info": "المصادقة الثنائية (2FA) هي ميزة أمان تضيف طبقة حماية إضافية إلى حسابك. تتطلب منك استخدام طريقتين لتسجيل الدخول بدلًا من اسم المستخدم وكلمة المرور فقط.",
          "method": {
            "email": "البريد الإلكتروني",
            "emailDesc": "استلم رموزًا لمرة واحدة عبر البريد الإلكتروني لإكمال طلبات المصادقة.",
            "oath": {
              "add": {
                "button": "تسجيل تطبيق المصادِق"
              }
            }
          }
        },
        "authenticator": "تطبيق المصادِق",
        "infoFederatedAccount": "هذا الحساب تديره الجهة المزوّدة للهوية في مؤسستك، لذا لا يمكن تغيير كلمة المرور من هنا. لتغيير كلمة المرور، سجّل الدخول عبر صفحة تسجيل الدخول الخاصة بمؤسستك أو تواصل مع مسؤول تقنية المعلومات لديك.",
        "lastUse": "آخر استخدام في {0}.",
        "msg": {
          "invalidPassword": "كلمة المرور الحالية غير صحيحة.",
          "passwordAlreadyUsed": "لا يمكن إعادة استخدام آخر 5 كلمات مرور.",
          "pwUpdateError": "حدث خطأ أثناء محاولة تغيير كلمة المرور.",
          "pwUpdated": "تم تغيير كلمة المرور."
        },
        "noDevice": "غير مُكوَّن",
        "oathAdd": {
          "appInfo": "لتسهيل عملية تسجيل الدخول إلى STIHL، يمكنك استخدام تطبيقات المصادقة مثل {0} و{1} و{2} وغيرها لإنشاء كلمات مرور لمرة واحدة تُستخدم كعامل ثانٍ أثناء عملية تسجيل الدخول.<br/>إذا فقدت جهازك المحمول أو نسيته، يمكنك دائمًا استخدام رمز المصادقة الثنائية المرسل عبر البريد الإلكتروني.<br/><br/>يرجى اتباع الإرشادات أدناه لإعداد جهاز المصادقة الخاص بك.",
          "badCode": "رمز غير صالح، يرجى المحاولة مرة أخرى.",
          "error": "حدث خطأ أثناء محاولة تسجيل جهاز المصادقة.",
          "headScan": "1. امسح رمز الاستجابة السريعة باستخدام تطبيق المصادِق",
          "headVerify": "2. تحقق من الرمز",
          "infoKey": "مفتاح الإعداد",
          "infoKeyTitle": "سر المصادقة الثنائية الخاص بك",
          "infoScanBottom": "يتعذر المسح؟ يمكنك استخدام {0} لإعداد تطبيق المصادِق يدويًا.",
          "infoVerify": "أدخل الرمز الذي أنشأه تطبيق المصادِق لديك.",
          "success": "تم تسجيل جهاز المصادقة الخاص بك. يمكنك الآن استخدامه لتسجيل الدخول.",
          "title": "سجّل جهاز المصادقة الثنائية الخاص بك"
        },
        "oathDelete": {
          "error": "حدث خطأ أثناء محاولة حذف جهاز المصادقة.",
          "success": "تم حذف جهاز المصادقة."
        },
        "passkeys": {
          "about": {
            "info1": "مفاتيح المرور هي أزواج من المفاتيح التشفيرية (مفتاح عام ومفتاح خاص) تُخزَّن بواسطة أداة مصادقة تتحكم بها. يمكن لأداة المصادقة إثبات وجود المستخدم وأنه مخوَّل لاستخدام مفتاح المرور. تُثبت أدوات المصادقة التفويض عبر رقم PIN أو رمز مرور أو البيانات الحيوية أو كلمة مرور الجهاز، حسب قدرات الأداة وتكوينها. تأتي أدوات المصادقة بأشكال عديدة مثل iPhone أو جهاز Android أو Windows Hello أو مفتاح أمان FIDO2 للأجهزة أو مدير كلمات المرور.",
            "info2": "عند تسجيل الدخول إلى STIHL باستخدام مفتاح مرور، تستخدم أداة المصادقة تشفير المفتاح العام لإثبات هويتك لـ STIHL دون إرسال مفتاح المرور نفسه أبدًا. ترتبط مفاتيح المرور بنطاق موقع ويب مثل stihl-sso.com وتتطلب اتصالًا آمنًا، مما يعني أن المتصفح سيرفض المصادقة على موقع تصيّد مشابه. تجعل هذه الخصائص مفاتيح المرور مقاومة بشدة للتصيّد وأصعب بكثير على الهجوم مقارنة برسائل SMS أو TOTP 2FA القابلة للتصيّد.",
            "info3": "تسمح خدمات مفاتيح المرور المدعومة بالسحابة بمزامنة مفاتيح المرور عبر الأجهزة (مثل أجهزة Apple أو Android أو مديري كلمات المرور) بحيث يمكن استخدامها من أماكن أكثر وباحتمال أقل للفقد. بمجرد إعداد مفتاح مرور متزامن على جهاز واحد، يصبح هذا المفتاح متاحًا للاستخدام عبر عدة أجهزة تستخدم الخدمة نفسها. على سبيل المثال، إذا سجّلت مفتاح مرور مع حساب iCloud الخاص بك باستخدام Touch ID في MacBook، فيمكنك بعد ذلك استخدام هذا المفتاح بوجهك أو بصمتك أو رقم PIN أو كلمة مرور الجهاز بالتبادل عبر أجهزة متعددة مرتبطة بالحساب نفسه.",
            "title": "حول مفاتيح المرور"
          },
          "add": {
            "button": "إضافة مفتاح مرور جديد",
            "error": "حدث خطأ أثناء محاولة إضافة مفتاح المرور الجديد.",
            "success": "تمت إضافة مفتاح مرور جديد."
          },
          "delete": {
            "button": "حذف مفتاح المرور",
            "error": "حدث خطأ أثناء محاولة حذف مفتاح المرور هذا.",
            "success": "تم حذف مفتاح المرور."
          },
          "edit": {
            "error": "حدث خطأ أثناء محاولة حفظ اسم مفتاح المرور.",
            "name": "اسم مفتاح المرور",
            "success": "تم تحديث اسم مفتاح المرور.",
            "title": "امنح مفتاح المرور اسمًا لتمييزه عن مفاتيح المرور الأخرى"
          },
          "info": "مفاتيح المرور بديل بسيط وآمن لكلمات المرور، تتحقق من هويتك باستخدام اللمس أو التعرف على الوجه أو كلمة مرور الجهاز أو رقم PIN.",
          "none": "لا يوجد مفتاح مرور مُكوَّن.",
          "reallyDelete": "هل أنت متأكد أنك تريد حذف مفتاح المرور؟",
          "registeredPasskeys": "مفاتيح المرور المسجلة لديك:",
          "title": "مفاتيح المرور"
        },
        "reallyDeleteDevice": "هل أنت متأكد أنك تريد حذف جهاز المصادقة؟",
        "secMFA": "المصادقة متعددة العوامل",
        "secPwdChange": "تغيير كلمة المرور",
        "title": "تسجيل الدخول والأمان"
      },
      "setPW": {
        "acceptTC": "يرجى تأكيد {terms} وقراءة {privacy} الخاصة بنا",
        "killSSO": "إبطال جميع الجلسات النشطة",
        "msg": {
          "tokenExpired": "رابط أو رمز كلمة المرور منتهي الصلاحية. يرجى اتباع الرابط لإعادة تعيين كلمة المرور: {link}."
        },
        "privacy": "سياسة الخصوصية",
        "terms": "الشروط والأحكام",
        "title": "أدخل كلمة مرور جديدة"
      }
    },
    "validations": {
      "hasDigit": "يجب أن تحتوي على رقم/أرقام",
      "hasLowercase": "يجب أن تحتوي على أحرف صغيرة",
      "hasSpecial": "يجب أن تحتوي على أحرف خاصة: {chars}",
      "hasUppercase": "يجب أن تحتوي على أحرف كبيرة",
      "invalidCharacters": "تحتوي على أحرف غير صالحة",
      "maxLength": "الحد الأقصى المسموح {max} من الأحرف",
      "minLength": "الحد الأدنى المطلوب {min} من الأحرف",
      "notSameAsEmail": "تشبه عنوان البريد الإلكتروني كثيرًا",
      "onlyValidCharactersAllowed": "يسمح فقط بالأحرف والأرقام والمسافات.",
      "required": "قيمة مطلوبة",
      "sameAsPassword": "كلمتا المرور غير متطابقتين",
      "tcAccepted": "يرجى تأكيد الشروط والأحكام.",
      "validEmail": "عنوان بريد إلكتروني غير صالح.",
      "validOTP": "يرجى إدخال رمز التحقق."
    }
  }
}
